import { connect } from "react-redux";

import { actions as userActions } from "../user";
import { actions as watchActions } from "../watch";

import WatchButton from "./WatchButton.view";

const mapStateToProps = state => ({
  user: state.login.user,
});

const mapDispatchToProps = dispatch => ({
  addWatchedListing: listingId => {
    dispatch(userActions.addWatchedListing(listingId));
    dispatch(watchActions.clear());
  },
  removeWatchedListing: (listingId, isWatchPatch) => {
    dispatch(userActions.removeWatchedListing(listingId));

    if (isWatchPatch) {
      dispatch(watchActions.remove(listingId));
    } else {
      dispatch(watchActions.clear());
    }
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(WatchButton);
